var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 207 207",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.37307 205.106C2.40738 202.927 1.75955 198.753 3.94068 195.786L70.444 105.1L31.5417 52.0497L42.296 44.1569L86.9864 105.1L14.7015 203.672C12.5203 206.64 8.34689 207.286 5.37307 205.106ZM23.6555 41.2954L15.7741 30.5411L26.5219 22.6484L34.4163 33.4026L23.6555 41.2954ZM7.88788 19.7885L0 9.0342L10.7543 1.15283L18.6405 11.9071L7.88788 19.7885Z",
    fill: "#FF7043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4506 205.106C36.4849 202.927 35.8371 198.753 38.0182 195.786L104.522 105.1L38.0248 14.4138C35.8436 11.4481 36.4914 7.27303 39.4571 5.09353C42.431 2.91403 46.6044 3.55372 48.7855 6.52754L121.07 105.1L48.779 203.672C46.5979 206.64 42.4245 207.286 39.4506 205.106V205.106Z",
    fill: "#FDD835"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 207,
    height: 207,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right.221aa650.svg";
export { ForwardRef as ReactComponent };